import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';

const reducer = (state, action) => {
  switch (action.type) {
    case types.REQUESTING: {
      return { ...state, requesting: action.requesting };
    }

    case types.CLEAR_SUCCESS_ERROR_FLAGS:
    case types.RESET_DATA: {
      return {};
    }

    case types.CHECK_LCI_CODE_INTERVIEWER: {
      return { ...state, join_access_code: action.join_access_code, liveToken: null };
    }

    case types.CHECK_LCI_CODE_INTERVIEWER_SUCCESS: {
      return { ...state, checkMessage: { type: 'success' }, lciList: action.result, count: action.count };
    }

    case types.CHECK_LCI_CODE_INTERVIEWER_ERROR: {
      return { ...state, checkMessage: { type: 'error' }, lciList: null, count: 0 };
    }

    case types.SET_JOIN_LCI_INFO: {
      return { ...state, join_lc_id: action.join_lc_id, join_user_id: action.join_user_id, lc_code_challenge: action.lc_code_challenge };
    }

    case types.SET_LIVE_TOKEN: {
      return { ...state, liveToken: action.liveToken, clientData: action.clientData };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_SETUP_ROOT, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'common';

export default { reducer, stateKey };
